import { h } from 'preact'

export const AdsBillboard = ({ adsId, analytics }) => {
   const hideBillboard = () => {
      const billboard = document.getElementById('billboard')
      if (billboard) {
         billboard.style.display = 'none'
      }
      document.cookie = 'helo_billboard_hidden=true; path=/; domain=.orange.fr;'
   }

   return (
      <div class="site-width">
         <div class="billboard-wrapper container-fluid">
            <div id={adsId} class="adsContainer"></div>
            <button
               onClick={() => hideBillboard()}
               title="Fermer la publicité"
               aria-label="Fermer la publicité"
               class="billboard-close-btn"
               data-pdb-zid={analytics.pdbZid}
               data-pdb-sc={analytics.pdbSc}
               data-pdb-idc={analytics.pdbIdc}
               data-pdb-vi={analytics.pdbVi}
               data-oevent-category={analytics.oeventCategory}
               data-oevent-action={analytics.oeventAction}
               data-oevent-label={analytics.oeventLabel}
               data-oevent-other={analytics.oeventOther}
            >
               &times;
            </button>
         </div>
      </div>
   )
}
